import React from 'react';
import { NavLink } from 'react-router-dom';

export default function Navigation() {
  return (
    <nav>
      {['/', '/design', '/quote', '/production', '/analytics', '/admin'].map((to, i) => {
        const label = ['Leads','Design','Quote','Production','Analytics','Admin'][i];
        return (
          <NavLink
            key={to}
            to={to}
            className={({isActive}) => isActive ? 'active' : ''}
          >
            {label}
          </NavLink>
        );
      })}
    </nav>
  );
}
